import React, { useEffect, useRef, useState } from "react";
import { Box, BoxProps } from "@chakra-ui/react";

interface RevealProps extends BoxProps {
  children: React.ReactNode;
  /** opóźnienie startu animacji w ms (do kaskadowania) */
  delay?: number;
  /** początkowe przesunięcie w pionie (px) */
  y?: number;
}

/** Płynne pojawianie się przy wejściu w widok (fade + slide-up). Jednorazowe. */
export const Reveal: React.FC<RevealProps> = ({ children, delay = 0, y = 26, ...props }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setVisible(true);
      return;
    }

    const io = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Box
      ref={ref}
      opacity={visible ? 1 : 0}
      transform={visible ? "translateY(0)" : `translateY(${y}px)`}
      transition={`opacity 0.6s ease ${delay}ms, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`}
      willChange="opacity, transform"
      {...props}
    >
      {children}
    </Box>
  );
};
